import React from 'react'
import './Products.css'
import Header from './Header'
import Footer from './Footer'
import Copyright from './Copyright'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GRSLogo from './Assets/grs_logo.png'
import ShopifyBadge from './Assets/badge-shopify-app-store-dark.png'
import MagentoBadge from './Assets/magento_badge.png'
import ShopifySS1 from './Assets/Screenshot_01.png'
import ShopifySS2 from './Assets/Screenshot_02.png'
import ShopifySS3 from './Assets/Screenshot_03.png'
import ShopifySS4 from './Assets/Screenshot_04.png'
import ShopifySS5 from './Assets/Screenshot_05.png'
import MagentoSS1 from './Assets/main_app_ss.png'
import MagentoSS2 from './Assets/app_ss.png'
import MagentoSS3 from './Assets/app_ss2.png'
import MagentoSS4 from './Assets/app_ss3.png'

const keywords = [
  "Google Reviews",
  "Google Review Display",
  "Google Reviews Showcase",
  "Google Reviews for Shopify",
  "Google Reviews for Magento",
  "Google Review Fetcher",
  "Google Reviews for eCommerce",
  "Google Reviews Integration",
  "Google Reviews Widget",
  "Google Reviews App",
  "Google Reviews Extension",
  "Google Reviews for Online Stores",
  "Google Reviews for Websites",
  "Google Reviews for Shopify Apps",
  "Google Reviews for Magento Apps",
  "Google Reviews for eCommerce Platforms",
  "Google Reviews for Shopify Themes",
  "Google Reviews for Magento Themes",
  "Google Reviews for Shopify Templates",
  "Google Reviews for Magento Templates",
  "Google Reviews for Shopify Plugins",
  "Google Reviews for Magento Plugins",
  "Google Reviews for Shopify Modules",
  "Google Reviews for Magento Modules",
  "Google Reviews for Shopify Extensions",
];


function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black", width: "50px", height: "50px", borderRadius: "50%", marginTop: "20px", marginLeft: "10px" }}
      onClick={onClick}>

    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black", width: "50px", height: "50px", borderRadius: "50%", marginTop: "20px", marginLeft: "10px" }}
      onClick={onClick}
    />
  );
}

const settings = {
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />
};

const Services = () => {
  return (
    <div >
          {/* <title>testing</title> */}
      <Header title={"Showcase Google Reviews for Shopify and Magento | Awwsome Products"} 
        metaDesc={"Showcase Google Reviews for Shopify and Magento | Awwsome Products"}
      />
      <div className='body-div'>
        <h1 className='page-heading'>Our Products</h1>
        <div className='divider-line'></div>
        <div className='flex-row space-between'>
          <div className='flex-row'>
            <img className='product-logo' src={GRSLogo} alt='product' />
            <div className='product-name-make'>
              <h2 className='product-name'>Google Review Showcase for Shopify</h2>
              <p className='product-make'>By Awwsome</p>
            </div>
          </div>
          <a href="https://apps.shopify.com/google-review-showcase" target='_blank' rel="noreferrer"> <img className='store-badge' src={ShopifyBadge} alt='product' /></a>
        </div>
        <div className='screen-shot-slider'>
          <Slider slidesToShow={1} slidesToScroll={1} dots={true} arrows={true} nextArrow={<p>hello</p>} {...settings}>
            <div className='slider-image'>
              <img src={ShopifySS1} alt='product' />
            </div>
            <div className='slider-image'>
              <img src={ShopifySS2} alt='product' />
            </div>
            <div className='slider-image'>
              <img src={ShopifySS3} alt='product' />
            </div>
            <div className='slider-image'>
              <img src={ShopifySS4} alt='product' />
            </div>
            <div className='slider-image'>
              <img src={ShopifySS5} alt='product' />
            </div>
          </Slider>
        </div>
        <div className='product-description'>
          <p className='product-description-text'>
            Showcase Google Reviews: Display Reviews, Filters, Sync, Different Layouts, Customization<br></br><br></br>
            Enhance your store's credibility and customer confidence by showcasing your store's Google reviews directly on your website. The Google Reviews Display Extension seamlessly integrates with your store, allowing you to fetch and display authentic customer feedback in an attractive and user-friendly format. By presenting real reviews from satisfied customers, you establish trust and provide valuable social proof, ultimately leading to increased conversions and customer loyalty.
            Key Features:
            <ul>
              <li>Different Layouts : Carousel, Slider, Grid, List</li>
              <li>Responsive design that looks awesome on any device</li>
              <li>Customization: background color, font color, heading alignment and heading title</li>
              <li>Auto sync : your reviews will always be fresh from your stores profile</li>
            </ul>
          </p>
        </div>

        <div className='divider-line'></div>

        <div className='flex-row space-between'>
          <div className='flex-row'>
            <img className='product-logo' src={GRSLogo} alt='product' />
            <div className='product-name-make'>
              <h2 className='product-name'>Google Business Review Showcase for Magento</h2>
              <p className='product-make'>By Awwsome</p>
            </div>
          </div>
          <a href='https://commercemarketplace.adobe.com/awwsome-google-review-fetcher.html' target='_blank' rel="noreferrer" ><img className='store-badge magento' src={MagentoBadge} alt='product' /></a>
        </div>
        <div className='screen-shot-slider'>
          <Slider slidesToShow={1} slidesToScroll={1} dots={true} arrows={true} nextArrow={<p>hello</p>} {...settings}>
            <div className='slider-image'>
              <img src={MagentoSS1} alt='product' />
            </div>
            <div className='slider-image'>
              <img src={MagentoSS2} alt='product' />
            </div>
            <div className='slider-image'>
              <img src={MagentoSS3} alt='product' />
            </div>
            <div className='slider-image'>
              <img src={MagentoSS4} alt='product' />
            </div>
          </Slider>
        </div>
        <div className='product-description'>
          <p className='product-description-text'>

            <div>
              <p>Enhance your Magento store's credibility and boost customer confidence by showcasing your store's Google reviews directly on your website. The Google Reviews Display Extension for Magento seamlessly integrates with your store, allowing you to fetch and display authentic customer feedback in an attractive and user-friendly format. By presenting real reviews from satisfied customers, you establish trust and provide valuable social proof, ultimately leading to increased conversions and customer loyalty.</p>

              <p>Our extension for Magento works by connecting your Magento store with your Google My Business profile, automatically retrieving and displaying the latest customer reviews. You can customize how these reviews appear on your site, ensuring a seamless blend with your existing design. Choose from multiple layout options to match your brand's aesthetic and improve user experience. With automated updates and responsive design, you can effortlessly keep your reviews fresh and relevant while maintaining a professional and engaging storefront.</p>

              <h2>Features</h2>
              <ul className='features-list'>
                <li><strong>Display Google Reviews on Your Magento Store</strong><br></br><br></br>
                  Effortlessly fetch and showcase real customer reviews from your Google My Business profile, reinforcing trust and authenticity among potential buyers.</li>
                <li><strong>Multiple Layout Options</strong><br></br><br></br>
                  Choose from four different display styles to match your store's aesthetics:
                  <ul>
                    <li><strong>Grid View</strong> - Arrange reviews in a structured grid layout for a clean and professional look.</li>
                    <li><strong>List View</strong> - Display reviews in a vertical list format, making them easy to scroll through.</li>
                    <li><strong>Slider Mode</strong> - Showcase reviews dynamically with an interactive sliding effect.</li>
                    <li><strong>Carousel View</strong> - Highlight top reviews in a rotating carousel for a more engaging experience.</li>
                  </ul>
                </li>
                <li><strong>Customizable Design</strong><br></br><br></br>
                  Easily adjust fonts, colors, and styles to seamlessly blend the reviews section with your store's existing theme and branding.</li>
                <li><strong>Responsive & Mobile-Friendly Design</strong><br></br><br></br>
                  Your reviews will look great on any device—desktop, tablet, or mobile. This extension for Magento is fully optimized for a seamless browsing experience across all screen sizes.</li>
                <li><strong>Boost Conversions & Trust</strong><br></br><br></br>
                  Displaying genuine reviews builds social proof, enhances your brand's credibility, and encourages hesitant buyers to complete their purchase with confidence.</li>
                <li><strong>Easy Setup & Configuration</strong><br></br><br></br>
                  Our intuitive admin panel allows store owners to integrate Google Reviews in just a few clicks—no technical expertise required!</li>
              </ul>

              <h2>Why Choose This Extension for Magento?</h2>
              <ul>
                <li>Helps improve SEO with fresh user-generated content</li>
                <li>Encourages customer engagement and interaction</li>
                <li>Increases customer retention and sales conversion rates</li>
                <li>Fully responsive design, optimized for desktop and mobile users</li>
              </ul>

              <p>Give your store the competitive edge it deserves by displaying trusted Google Reviews and enhancing customer engagement effortlessly.</p>
            </div>


          </p>
        </div>
        <div className='divider-line'></div>
      <div className='tags'>
        <h2 className='tags-heading'>Keywords</h2>
        <div className='tags-list'>
          {keywords.map((keyword, index) => (
            <span key={index} className='tag'>{keyword},</span>
          ))}
        </div>

      </div>
      </div>
      <Footer />
      <Copyright />
    </div>

  )
}

export default Services